import { FC, HTMLAttributes } from "react";
import { Avatar, Box, Typography } from "@mui/material";
import { millisToTime } from "@/services/dateTimeService";
import { useResponsiveContext } from "@context/ResponsiveContext";
import { GameSelectionDropdownOption } from "@components/controls/GameSelectionDropdown";

const GameSelectionLine: FC<{
  props?: HTMLAttributes<HTMLLIElement> & {
    key: any;
  };
  option: GameSelectionDropdownOption;
  showImagesOnDesktop: boolean;
}> = ({ props, option, showImagesOnDesktop }) => {
  const { onMobile } = useResponsiveContext();

  return (
    <li
      {...props}
      style={{ padding: onMobile ? "10px 6px" : "16px 24px", maxWidth: "100%" }}
    >
      <Box
        display={"flex"}
        justifyContent={"flex-start"}
        alignItems={"center"}
        gap={"20px"}
        maxWidth={"100%"}
      >
        {!onMobile && showImagesOnDesktop && (
          <>
            <Avatar
              src={option.gameData.team1.iconUrl}
              slotProps={{ img: { loading: "lazy" } }}
            />
            <Avatar
              src={option.gameData.team2.iconUrl}
              slotProps={{ img: { loading: "lazy" } }}
            />
          </>
        )}
        <Typography
          whiteSpace={"nowrap"}
          overflow={"hidden"}
          textOverflow={"ellipsis"}
          pr={"40px"}
        >
          {`${millisToTime(option.gameData.gameStartDateTime)} Uhr: ${option.gameData.team1[onMobile ? "shortName" : "longName"]} vs. ${option.gameData.team2[onMobile ? "shortName" : "longName"]}`}
        </Typography>
      </Box>
    </li>
  );
};

export default GameSelectionLine;
